import {TaskEvent} from "@core/model";
import {CalendarEvent} from "./Event";
import {
  Box,
  ButtonBase,
  Paper,
  Popover,
  Stack,
  Typography,
} from "@mui/material";
import {useState} from "react";
import dayjs from "dayjs";

const ShowMore = ({
  events,
  date,
  onEventClick,
}: {
  events: TaskEvent[];
  date: Date;
  onEventClick: (event: TaskEvent) => void;
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <>
      <Box className="rbc-row-segment">
        <ButtonBase
          className="rbc-show-more"
          onClick={handleClick}
          sx={{pl: 0.5}}>
          +{events.length}
        </ButtonBase>
      </Box>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{vertical: "top", horizontal: "center"}}
        onClose={handleClose}>
        <Paper>
          <Stack p={1} gap={1}>
            <Stack>
              <Typography
                variant="body2"
                textAlign={"center"}
                textTransform={"uppercase"}>
                {dayjs(date).format("ddd")}
              </Typography>
              <Typography variant="h6" textAlign={"center"}>
                {dayjs(date).format("DD")}
              </Typography>
            </Stack>
            {events.map((event, index) => (
              <Box
                key={index}
                className="rbc-event"
                px={1}
                onClick={() => onEventClick(event)}>
                <CalendarEvent event={event} />
              </Box>
            ))}
          </Stack>
        </Paper>
      </Popover>
    </>
  );
};

export {ShowMore};
